export interface PartnersState {
  list: Partner[] | null;
  partnersLoading: boolean;
  partner: any;
}

export interface Partner {
  id: string;
  name: string;
  mobilityPartnerId: string | null;
  countryId: string;
  depots: any[];
  currency: string;
  source: BusPartnerSource;
  status: BusPartnerStatus;
}

export enum BusPartnerSource {
  Cpc = 'CPC',
  Mpp = 'MPP'
}

export enum BusPartnerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}
